<template>
  <footer>
    <section class="footer_contents">
      <div class="footer_contents_box">
        <a href="https://geeklabs.co.jp/" target="_blank" rel="noopener noreferrer"><img src="../assets/img/glc_logo.svg" alt="GLC" class="glc_logo"></a>
        <span class="small">Copyright ©️ {{ year }} GLC inc. All Rights Reserved.</span>
      </div>
      <a href="https://twitter.com/GLC_smartmirror" target="_blank" rel="noopener noreferrer"><img src="../assets/img/twitter.svg" alt="twitter" class="twitter"></a>
    </section>
  </footer>
</template>

<script>
export default {
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped>
.glc_logo {
  height: 24px;
  margin-right: 40px;
}
footer {
  background-color: #000000;
  padding: 80px 0px 120px;
}
.footer_contents {
  max-width: 960px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
}
span.small {
  color: #ffffff;
  font-family: "Noto Sans JP", sans-serif;
  font-size: 15px;
  font-weight: normal;
  font-feature-settings: "palt";
  line-height: 1;
  letter-spacing: 1px;
  margin-left: 5px;
}
.twitter {
  height: 60px;
}

@media screen and (max-width: 821px) {
  .footer_contents{
    max-width: 700px;
}
}
@media screen and (max-width: 599px) {
  .footer_contents {
    max-width: 350px;
    margin: auto;
  }
  footer {
    padding: 30px 0px 80px;
  }
  span.small{
    font-size: 10px;
    letter-spacing:0;
  }
  .twitter{
    height: 45px;
  }
  .glc_logo{
    margin-right: 1px;
  }
}
</style>
